import { render, staticRenderFns } from "./SupplierStore.vue?vue&type=template&id=b451836c&scoped=true&"
import script from "./SupplierStore.vue?vue&type=script&lang=js&"
export * from "./SupplierStore.vue?vue&type=script&lang=js&"
import style0 from "./SupplierStore.vue?vue&type=style&index=0&id=b451836c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b451836c",
  null
  
)

export default component.exports